import { render, staticRenderFns } from "./AppointmentCanceledView.vue?vue&type=template&id=0c819233"
import script from "./AppointmentCanceledView.vue?vue&type=script&lang=js"
export * from "./AppointmentCanceledView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports